module.exports = __webpack_public_path__ + "static/img/e8b9a81.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/xzlj/img/logo@3x.png
// module id = 706
// module chunks = 2